<div class="modal inmodal fade in parcel-modal create-edit-parcel-modal" [ngClass]="{'show': showModal}">
    <form #form="ngForm" (ngSubmit)="onSubmit(form)" submittable autocomplete="off">
        <div class="modal-dialog ">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" (click)="hideModal()">
                        <span>×</span><span class="sr-only">Close</span>
                    </button>
                    <h4 class="modal-title col-md-6">Create New Classified</h4>
                    <h4 class="modal-title col-md-6">Classified Preview</h4>
                </div>
                <div class="modal-body classifieds-modal-body">
                    <div class="details">
                        <div class="row m-b-sm inlineDateAndTime inline-date-time-classifieds">
                            <div class="col-md-2">
                                <label>Start</label>
                            </div>
                            <div class="col-md-4">
                                <mat-form-field>
                                    <input matInput [(ngModel)]="startDate" name="startDate"
                                           (focus)="startDatePicker.open()" (click)="startDatePicker.open()"
                                           [matDatepicker]="startDatePicker" placeholder="Choose a date">
                                    <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
                                    <mat-datepicker #startDatePicker></mat-datepicker>
                                </mat-form-field>
                            </div>
                            <div class="col-md-2">
                                <label>End</label>
                            </div>
                            <div class="col-md-4">
                                <mat-form-field>
                                    <input matInput [(ngModel)]="expiryDate" [min]="startDate" name="expiryDate"
                                           (focus)="expiryDatePicker.open()" (click)="expiryDatePicker.open()"
                                           [matDatepicker]="expiryDatePicker" placeholder="Choose a date">
                                    <mat-datepicker-toggle matSuffix [for]="expiryDatePicker"></mat-datepicker-toggle>
                                    <mat-datepicker #expiryDatePicker></mat-datepicker>
                                </mat-form-field>
                            </div>
                        </div>

                        <!-- ___ Title ___ -->
                        <div class="row m-b-sm">
                            <div class="col-md-3">
                                <label>Buildings</label>
                            </div>
                            <div class="col-md-9">
                                <angular2-multiselect [data]="classifiedsMccService.buildings"
                                                      name="buildings"
                                                      [(ngModel)]="model.buildings"
                                                      [settings]="multiselectSettings">
                                </angular2-multiselect>
                            </div>
                        </div>

                        <!-- ___ Title ___ -->
                        <div class="row m-b-sm">
                            <div class="col-md-3">
                                <label>Title</label>
                            </div>
                            <div class="col-md-9">
                                <input class="form-control" name="title" [(ngModel)]="model.title" required>
                            </div>
                        </div>

                        <!-- ___ Description ___ -->
                        <div class="row m-b-sm">
                            <div class="col-md-3">
                                <label>Description</label>
                            </div>
                            <div class="col-md-9">
                                <textarea class="form-control" name="description" maxlength="255" [(ngModel)]="model.description">
                                </textarea>
                            </div>
                        </div>

                        <!-- ___ Name ___ -->
                        <div class="row m-b-sm">
                            <div class="col-md-3">
                                <label>Name</label>
                            </div>
                            <div class="col-md-9">
                                <input class="form-control" name="name" [(ngModel)]="model.name" required>
                            </div>
                        </div>

                        <!-- ___ Email ___ -->
                        <div class="row m-b-sm">
                            <div class="col-md-3">
                                <label>Email</label>
                            </div>
                            <div class="col-md-9">
                                <input class="form-control" name="email" [(ngModel)]="model.email" required>
                            </div>
                        </div>

                        <!-- ___ Phone ___ -->
                        <div class="row m-b-sm">
                            <div class="col-md-3">
                                <label>Phone</label>
                            </div>
                            <div class="col-md-9">
                                <input class="form-control" name="phone" [(ngModel)]="model.phone" required>
                            </div>
                        </div>


                        <!-- ___ Images  ___ -->
                        <div class="row m-b-sm">
                            <div class="col-xs-4 col-md-4">
                                <label>Images</label>
                            </div>
                            <div class="col-xs-8 col-md-8">
                                <input type="file" name="attachment" accept=".gif, .jpeg, .png, .jpg, .bmp, .pcx, .tiff"
                                       id="add-attachment-button" (change)="addFile($event)" hidden
                                       [disabled]="disabledFileInput">
                                <label for="add-attachment-button" class="btn mtv-primary-color">Add Image</label>
                            </div>
                        </div>
                        <ul class="attachment-box">
                            <li *ngFor="let item of attachments; let i = index;">
                                <a (click)="classifiedsMccService.showAttachment(item)">
                                    <div>
                                        <span class="file-name">{{item.name}}</span>
                                    </div>
                                </a>
                                <i class="fa fa-trash" (click)="removeFile(i)" title="Delete Attachment"></i>
                            </li>
                        </ul>

                        <div class="row text-center space-30">
                            <button type="button"
                                    class="btn btn-outer-primary mtv-primary-color mtv-primary-border"
                                    [disabled]="disabledSubmit">
                                Cancel
                            </button>
                            <button type="submit" class="btn btn-primary submit-btn" [disabled]="disabledSubmit">Save</button>
                        </div>
                    </div>
                    <div class="classified">
                        <div class="m-b-sm images-upload">
                            <i class="fa fa-chevron-left"
                               [ngStyle]="{'visibility': attachments.length > 0 && currentImageIndex > 0 ? 'visible' : 'hidden'}"
                               (click)="showPreviousImage()">
                            </i>
                            <div class="image" [style.background-image]="getBackground() ? getBackground() : ''">
                            </div>
                            <i class="fa fa-chevron-right"
                               [ngStyle]="{'visibility': attachments.length > 0 && currentImageIndex < attachments.length - 1 ? 'visible' : 'hidden'}"
                               (click)="showNextImage()">
                            </i>
                        </div>
                        <div class="m-b-sm">{{model.title}}</div>
                        <div class="m-b-sm classified-content">{{model.description}}</div>
                        <div class="m-b-sm">
                            <div class="personal-info">
                                <i class="fa fa-envelope"></i>
                                {{model.email}}
                            </div>
                        </div>
                        <div class="m-b-sm">
                            <div class="personal-info">
                                <i class="fa fa-phone"></i>
                                {{model.phone}}
                            </div>
                        </div>
                        <div>
                            <div class="personal-info">
                                <i class="fa fa-user"></i>
                                {{model.name}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
    <div class="modal-backdrop fade in" (click)="hideModal()"></div>
</div>
<view-attachment-modal *ngIf="classifiedsMccService.es.isViewAttachmentModalShow"></view-attachment-modal>



// WEBPACK FOOTER //
// /app/src/app/views/classifieds-mcc/classifieds-mcc-modal/classifieds-mcc-modal.component.html